// Errors that will fail the same way every time — retrying only delays the real message.
const PERMANENT_CODES = new Set([
  '42703', // undefined column
  '42P01', // undefined table
  '42501', // insufficient privilege (RLS)
  '23505', // unique violation
  'PGRST116', // .single()/.maybeSingle() row-count mismatch
  'PGRST204', // column not in schema cache
  'PGRST205', // table not in schema cache
]);

function isPermanentError(error) {
  return PERMANENT_CODES.has(String(error?.code || ''));
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Runs a Supabase read and retries transient failures (network blips, timeouts, 5xx, cold starts).
 * `run` must build a fresh query each call. Resolves to the usual { data, error } shape.
 */
export async function withRetry(run, { attempts = 3, baseDelayMs = 400 } = {}) {
  let lastError = null;
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      const result = await run();
      if (!result?.error || isPermanentError(result.error)) return result;
      lastError = result.error;
    } catch (err) {
      lastError = err;
    }
    if (attempt < attempts - 1) await sleep(baseDelayMs * 2 ** attempt);
  }
  return { data: null, error: lastError };
}
